/**
 * detectSuggestions.js — s126 (TestFlight build 92 note 7 "Ux is a little complicated/busy"; canvas "Orella Diagnostic
 * Scales" board A2, copy approved 2026-10-31).
 *
 * Detect shows at most SUGGESTION_BUDGET suggestion cards before "N more suggestions · Show". Order of the budget:
 *   1. pinned records ("You mentioned this") — ALWAYS shown, even past the budget: they come from the patient's answers;
 *   2. the AI's capture cards (photo / video);
 *   3. the AI's prior-record rows.
 * A card that already holds a file is never hidden (the patient must see what they attached): any such card opens the
 * whole list. Pure module; check-s126-fixes executes it.
 */
export const SUGGESTION_BUDGET = 3

export function budgetSuggestions({ pinned = [], captures = [], records = [], showAll = false, captureHasFiles = () => false, recordHasFiles = () => false, max = SUGGESTION_BUDGET }) {
  const open = showAll || captures.some((x) => captureHasFiles(x)) || records.some((x) => recordHasFiles(x))
  if (open) return { captures, records, hidden: 0, open: true }
  let left = Math.max(0, max - pinned.length)
  const c = captures.slice(0, left); left -= c.length
  const r = records.slice(0, Math.max(0, left))
  return { captures: c, records: r, hidden: (captures.length - c.length) + (records.length - r.length), open: false }
}
